import React from 'react';
import PropTypes from 'prop-types';

import translate from '../../../utils/js/translateTableHead';
import translateTableHead from '../../../utils/js/translateTableHead';

const Th = ({ children }) => (
  <th style={{ textAlign: 'center' }}>{children}</th>
);

Th.propTypes = {
  children: PropTypes.string,
};

const Td = ({ children }) => (
  <td style={{ textAlign: 'center' }}>{children}</td>
);

Td.propTypes = {
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const Tableau = ({ data, locale }) => {
  if (!data) {
    return <div />;
  }

  let tHead = []; // pour avoir les index des data excel
  let tHeadStrings = []; // pour avoir les titre des entêtes
  Object.keys(data[0].node).forEach(key => {
    tHead.push(key);
    tHeadStrings.push(translateTableHead(key, locale));
  });

  return (
    <div className="container table-responsive table-striped table-hover">
      <table className="table table-sm">
        <thead>
          <tr>
            {tHeadStrings.map(title => {
              return <Th key={title}>{title}</Th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data.map(({ node }, i) => {
            return (
              <tr key={`${node.modele}-${i}`}>
                {tHead.map(index => {
                  return <Td key={index}>{node[index]}</Td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

Tableau.propTypes = {
  data: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
};

export default Tableau;



// WEBPACK FOOTER //
// ./src/components/Main/brand/Tableau.js